import { useGem } from "../../../../Utils/UseGem";
import { IvrCampaign } from "./IvrUserSkillsConfig";

const useGetIvrCampaigns = () => {
  const { res, loading } = useGem<IvrCampaign[]>({ url: "Legacy/V0/ivr/campaigns" });

  return { res: res?.payload, loading };
};

export default useGetIvrCampaigns;
